// Flatpickr-based date field — ported from twifi-theme-html/src/scripts/helpers/date-picker.js.
// Distinct from lib/datepicker.js (jQuery UI, still used by the Verification tab's #atid_dob and
// the legacy, non-redesigned checkout's #subscription_start_date) — this one is used by
// [data-datepicker] fields ported from the reference, plus the Personal Info tab's
// #date_of_birth field (templates/account.twig).
import flatpickr from 'flatpickr';

document.addEventListener('DOMContentLoaded', () => {
    const startDate = document.querySelector('#subscription_start_date[data-datepicker]');

    if (startDate) {
        const maxStartDate = new Date();
        maxStartDate.setMonth(maxStartDate.getMonth() + 3);

        flatpickr(startDate, {
            dateFormat: 'd.m.Y',
            disableMobile: true,
            minDate: 'today',
            maxDate: maxStartDate,
        });
    }

    const dateOfBirthFields = document.querySelectorAll(
        '#twf_date_of_birth[data-datepicker], #date_of_birth[data-datepicker]'
    );

    if (dateOfBirthFields.length) {
        const minDateOfBirth = new Date();
        minDateOfBirth.setFullYear(minDateOfBirth.getFullYear() - 90);

        dateOfBirthFields.forEach((dateOfBirth) => {
            flatpickr(dateOfBirth, {
                dateFormat: 'd.m.Y',
                disableMobile: true,
                maxDate: 'today',
                minDate: minDateOfBirth,
            });
        });
    }
    // Excludes the IDs handled by the bespoke blocks above (they carry [data-datepicker] too,
    // for markup consistency, but already get their own min/max logic and must not be
    // double-initialized here).
    document
        .querySelectorAll('[data-datepicker]:not(#subscription_start_date):not(#twf_date_of_birth):not(#date_of_birth)')
        .forEach((input) => {
            const options = {
                dateFormat: 'd.m.Y',
                disableMobile: true,
            };

            // Past-dated fields (birthdates, ...) are the default: capped at today. Future-dated
            // fields (ID expiration, ...) opt in with data-datepicker-min instead, e.g. ="today".
            if (input.dataset.datepickerMin) {
                options.minDate = input.dataset.datepickerMin;
            } else {
                options.maxDate = 'today';
            }

            flatpickr(input, options);
        });
});
